import React, {useEffect, useContext} from 'react';
import {Route, Switch} from 'react-router-dom';
import {ExpenseProgramManagementMenu} from '../Expenses/ExpenseProgramManagementMenu';
import {ExpenseProgramManagement} from '../Expenses/ExpenseProgramManagement';
import {AppContext} from '../../context/app/appContext';

export const ExpensesPage = (props) => {

  const appContext = useContext(AppContext);
  useEffect(() => {
    if (!appContext.teams.length) {
        (async function loadTeams() {
            await appContext.loadTeams();
        })();
    }
    // eslint-disable-next-line
}, []);

useEffect(() => {
    if (!appContext.employees.length) {
        (async function loadEmployees() {
            await appContext.setEmployees();
        })();
    }
    // eslint-disable-next-line
}, []);

  return (
      <div id="app" style={{width: '90vw', marginRight: 0, paddingRight: 0}}>
        <ExpenseProgramManagementMenu/>
          <Switch>
              <Route path="/programs/expense-programs/active"><ExpenseProgramManagement/></Route>
              <Route path="/programs/expense-programs/expired"><ExpenseProgramManagement/></Route>
              <Route path="/programs/expense-programs"><ExpenseProgramManagement/></Route>
          </Switch>
      </div>
  );
};
